import { AbstractApiService } from "../abstractions/AbstractApiService";
import { OnRequestSuccess, OnRequestError } from "./Responses";
import { ISearchData } from "../models/ISearchData";
import { IsNullEmptyOrUndefined } from "../utils/IsNullEmptyOrUndefined";


export class SearchService extends AbstractApiService {
    constructor() {
        super();
    }
    
    //public GetDiseases(searchValue: string, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
    //    this.Get('api/search/diseasecategoriessearchdata?searchValue=' + encodeURI(searchValue), onSuccess, onError);
    //}//Nie jest już używane

    //public GetTherapies(searchValue: string, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
    //    this.Get('api/search/therapiessearchdata?searchValue=' + encodeURI(searchValue), onSuccess, onError);
    //}

    public GetPlaces(searchValue: string, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Get('api/search/getplacessearchdata?searchValue=' + encodeURI(searchValue), onSuccess, onError);
    }

    public GetDefaultPlaces(onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Get('api/search/getdefaultplacesdata', onSuccess, onError);
    }

    public GetClosestCity(lat: number, lng: number, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Get('api/search/getclosestcity?lat=' + lat + '&lng=' + lng, onSuccess, onError);
    }

    public GetAllCategories(onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Get('api/search/getallcategories', onSuccess, onError);
    }

    public GetAllCategoriesFooter(onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Get('api/search/getallcategoriesfooter', onSuccess, onError);
    }

    public GetCombainedSearchData(searchValue: string, onSuccess: OnRequestSuccess, onError: OnRequestError): void {
        this.Get('api/search/getcombinedsearchdata?searchValue=' + encodeURI(searchValue), onSuccess, onError);
    }

    public GetAdvancedSearchData(criteria: ISearchData, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Post('api/search/getadvancedsearchresult', criteria, onSuccess, onError);
    }

    public GetAllPhysiotherapistsTherapies(physiotherapistId: string, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/search/getalltherapies?physiotherapistId=' + physiotherapistId.toString(), onSuccess, onError);
    }
    
    public GetBasicSearchData(city: string | undefined, disease: string | undefined, onSuccess: OnRequestSuccess, onError: OnRequestError) {
        this.Get('api/search/getbasicsearchdata?'
            + (IsNullEmptyOrUndefined(city) ? '' : ('city=' + encodeURI(city as string)))
            + (!IsNullEmptyOrUndefined(city) && !IsNullEmptyOrUndefined(disease) ? '&' : '')
            + (IsNullEmptyOrUndefined(disease) ? '' : ('disease=' + encodeURI(disease as string)))
            , onSuccess, onError);
    }
}


// WEBPACK FOOTER //
// ./src/services/SearchService.tsx